import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('LOCATION_CITIES').plugin(axiosPlugin, {template: "array"});

let fetchLocationCitiesAction = redux.fetchActionGet();

export const fetchLocationCities = (query = {}) => fetchLocationCitiesAction(`/locations?${queryString.stringify(query)}`);
export const fetchLocationSearchCities = (query = {}) => fetchLocationCitiesAction(`/locations/search-cities?${queryString.stringify(query)}`);
export const resetLocationCities = () => redux.actions.reset();

export const locationCities = redux.reducer();